/** #Fase1-10 — Tras un PUT confirmado, un fallo del GET no debe mostrar la respuesta que N/A borró. */
export function applyReviewNA(evaluation, criterion, partial, totals = {}) {
  const matches = (item) => {
    const id = item.criterio_id ?? item.criterion_id ?? item.question_id ?? item.id;
    return (
      String(id) === String(criterion.id) ||
      (criterion.question_id != null && item.question_id === criterion.question_id)
    );
  };
  const patch = { ...partial };
  if (partial.not_applicable === true) {
    Object.assign(patch, {
      score: 0,
      score_set: false,
      has_been_scored: false,
      answer_text: null,
      answer_numeric: null,
      answer_date: null,
      answer_bool: null,
      selected_options: [],
      status: 'no_aplica',
      missing: [],
      is_finding: false,
      below_standard: false,
      auto_recommendation: null,
    });
  } else if (partial.not_applicable === false) {
    Object.assign(patch, { status: 'sin_contestar', missing: [] });
  }
  const update = (item) => (matches(item) ? { ...item, ...patch } : item);
  return {
    ...evaluation,
    // La API devuelve totales; si no llegan, se muestran como no disponibles hasta refrescar.
    score_summary: undefined,
    ...totals,
    items: (evaluation.items || []).map(update),
    sections: (evaluation.sections || []).map((section) => ({
      ...section,
      criteria: (section.criteria || []).map(update),
    })),
  };
}
